import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";

import { FeatureHighlight } from "./feature-highlight.model";

/**
 * Kilde til highlights. Appen vælger implementering, fx `provideUmbracoDeliveryFeatureHighlights()`.
 * En Heartcore-kilde er blot en ny klasse + provider-swap. Uden provider vises ingen highlights.
 *
 * Emitter kun ved gyldigt svar — ved fejl skal den completere uden værdi. Et emittet svar er den fulde liste,
 * og dismiss-historik for highlights der ikke findes i den, ryddes fra LocalStorage.
 */
@Injectable({ providedIn: "root", useFactory: () => ({ hent: () => of([]) }) })
export abstract class FeatureHighlightSource {
    public abstract hent(): Observable<FeatureHighlight[]>;
}
